import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Highcharts from "./HighchartsMixins";
import { DATA_SET_CHANGE } from "../../../../redux/actions/graphs";
import Header from "./graphComponents/Header";
import Graph from "./graphComponents/Graph";
import Summary from "./graphComponents/Summary";
import Tab from "./graphComponents/Tab";
import { useEffect } from "react";
import setInitialFigureOptions from "./setInitialFigureOptions";
import initialToggleOptions from "./initialToggleOptions";
import HSAMap from "./HSAMap";
import StateMap from "./StateMap";
import CountyMap from "./CountyMap";
import Image from "./Image";

const TabOnly = ({ serverdata, slug, size }) => {
  const data = serverdata;

  const dispatch = useDispatch();
  const graphState = useSelector(
    (state) => state.graphState[data.figureNumber]
  );

  // determine current possible tab values and select the default one selected
  const tabValues = Array.from(new Set(data.tabOnly.flatMap((x) => x.tab)));
  const cTab = graphState && graphState.tab ? graphState.tab : tabValues[0];
  const [currentTab, setTab] = useState(cTab);

  const [options, setOptions] = useState();

  useEffect(() => {
    let newOptions = {
      title: {
        text: currentTab,
      },
    };
    newOptions = setInitialFigureOptions(
      initialToggleOptions(),
      data,
      [],
      size,
      currentTab,
      null
    );

    setOptions(newOptions);
  }, [currentTab, data, size]);

  const tabDataSet = (newTab) => {
    setTab(newTab);
    dispatch({
      type: DATA_SET_CHANGE,
      payload: {
        figureNumber: data.figureNumber,
        tab: newTab,
      },
    });
  };

  let graph = <Graph highcharts={Highcharts} options={options} size={size} />;
  if (data.chartType === "HSA MAP") {
    graph = <HSAMap data={data} size={size} tab={currentTab} />;
  } else if (data.chartType === "STATE MAP" || data.chartType === "MAP") {
    graph = <StateMap data={data} size={size} tab={currentTab} />;
  } else if (data.chartType === "COUNTY MAP") {
    graph = <CountyMap data={data} size={size} tab={currentTab} />;
  } else if (data.chartType === "IMAGE") {
    graph = <Image serverdata={data} size={size} slug={slug} tab={currentTab} />;
  
}  

  if (process.env.REACT_APP_PRINT === "true") return TabOnlyPrint(tabValues, data, slug, size);

  return (
    <>
      {size !== "micro" ? (
        <>
          <Header figureData={data} slug={slug} currentTab={currentTab} />
          <Tab
            currentTab={currentTab}
            tabDataSet={tabDataSet}
            tabValues={tabValues}
          />
        </>
      ) : (
        <></>
      )}
      {options ? graph : <></>}
      <Summary figureData={data} size={size} />
    </>
  );
};

export default TabOnly;

const TabOnlyPrint = (tabValues, data, slug, size) => {
   const graphs = [];
   const tabSelections = Array.from(new Set(data.figurePrint.flatMap((x) => x.tab)));
   tabSelections.forEach(item => {
    if (tabValues.includes(item))
    {
      let printoptions = {
        title: {
          text: item,
        },
      };
      printoptions = setInitialFigureOptions(
        initialToggleOptions(),
        data,
        [],
        size,
        item,
        null
      );

      let printgraph = <Graph highcharts={Highcharts} options={printoptions} size={size}/>;
      if (data.chartType === "HSA MAP") {
        printgraph = <HSAMap data={data} size={size} tab={item} />;
      } else if (data.chartType === "STATE MAP" || data.chartType === "MAP") {
        printgraph = <StateMap data={data} size={size} tab={item} />;
      } else if (data.chartType === "COUNTY MAP") {
        printgraph = <CountyMap data={data} size={size} tab={item} />;
      } else if (data.chartType === "IMAGE") {
        printgraph = <Image serverdata={data} size={size} slug={slug} tab={item} />;
      } 
      graphs.push(printgraph);
    }
  });
  
  return (
    <>
      {size !== "micro" ? (
        <>
          <Header figureData={data} slug={slug} />
        </>
      ) : (
        <></>
      )}
      {graphs.map((item, index) => (
        <div key={index} className="figure-print">
          {item}
        </div>
      ))}
      <Summary figureData={data} size={size} />
    </>
  ); 
};